import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import { getVersionsApiCrud, type GetVersionsRequest } from "@/generated/fastapi";

export async function getVersions(
  accessToken: string | null | undefined,
  request: GetVersionsRequest = {},
) {
  const response = await getVersionsApiCrud({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200) {
    throw new Error(`Failed to retrieve versions (${response.status})`);
  }

  return response.data ?? [];
}
